import { ThresholdLevel } from '@vista/diagnostics'
import type { LoggerConfigurationPropsApi } from '../../cms/core-components/loggerConfiguration/models'
import type { CmsLogLevel } from '../../cms/types/cmsLogLevel'

export type LoggerConfiguration = LoggerConfigurationPropsApi[]

export function getThresholdLevelFromLogLevel(logLevel: CmsLogLevel): ThresholdLevel {
    switch (logLevel) {
        case 'Trace':
            return ThresholdLevel.TRACE
        case 'Debug':
            return ThresholdLevel.DEBUG
        case 'Info':
            return ThresholdLevel.INFO
        case 'Warn':
            return ThresholdLevel.WARN
        case 'Error':
            return ThresholdLevel.ERROR
        default:
            return ThresholdLevel.SILENT
    }
}

export interface LogFunctions {
    trace: (message: string, ...args: unknown[]) => void
    debug: (message: string, ...args: unknown[]) => void
    info: (message: string, ...args: unknown[]) => void
    warn: (message: string, ...args: unknown[]) => void
    error: (message: string, ...args: unknown[]) => void
}
